<template>
  <nav>
    <v-app-bar flat>
        <v-app-bar-nav-icon class="indigo--text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="text-uppercase grey--text">
            <!-- <span class="font-weight-light">tt</span><span>m</span> -->
        </v-toolbar-title>

        <!-- enter my room -->
        <!-- <v-btn v-if="user" icon small router :to="{ name: 'Home'}">
            <v-icon>mdi-home-outline</v-icon>
        </v-btn> -->

        <v-spacer></v-spacer>
        
        <!-- email -->
        <!-- <span v-if="user" class="grey--text font-italic mr-3">{{ user.email }}</span> -->

        <!-- log out -->
        <!-- <v-btn v-if="user" icon small class="indigo--text" @click="logout">
            <v-icon>mdi-logout</v-icon>
        </v-btn> -->

    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
            <v-list-item two-line v-if="this.user">
                <v-list-item-avatar>
                    <img :src="this.user.avatar">
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>{{this.user.name}}</v-list-item-title>
                    <v-list-item-subtitle>logged in</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list>
                <v-list-item v-for="link in links" :key="link.title" router :to="link.route">
                    <v-list-item-icon>
                        <v-icon>{{ link.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ link.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
  </nav>

</template>

<script>
// import Signup from '@/components/Signup'
// import Login from '@/components/Login'
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
    name: 'Navbar',
    data: () => ({
        drawer: false,
        user: null,
        links: [
          { title: '홈', icon: 'mdi-home-city', route: '/' },
          { title: '내 방', icon: 'mdi-account', route: '/my-room' },
          { title: '내 게임들', icon: 'mdi-lan', route: '/my-games' },
          { title: '회원', icon: 'mdi-account-multiple-outline', route: '/members' },
        ],
        dialog: false
    }),
    created(){
        firebase.auth().onAuthStateChanged(user => {
            if(user){
                this.user = user;
            } else {
                this.user = null;
            }
        })
    },
    methods: {

    },  
};
</script>

<style>

</style>